export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER'
export const LOGIN_STATUS = 'LOGIN_STATUS'
export const REGISTER_STATUS = 'REGISTER_STATUS'
export const NEED_VERIFY = 'NEED_VERIFY'
export const USER_ROLES = 'USER_ROLES'